import { useAuth } from "m2m-components/storage/useM2mAuth"
import { Chip, Typography } from "matsuri-ui"
import { css } from "@emotion/react"
import EllipseIcon from "../../../components/Icon/Ellipse.svg"
import { usePlacementName } from "./usePlacementName"
import { usePhotoTourByCleaningId } from "@/hooks/usePhotoTour"
import { showJpYen } from "@/utils/showJpYen"
import { theme } from "@/theme"

export const CleaningPlace = ({
    cleaningId,
    cleaningPrice
}: {
    cleaningId?: string
    cleaningPrice?: number
}) => {
    const { token } = useAuth()
    const { data: tour } = usePhotoTourByCleaningId(token, cleaningId)
    const { placementName } = usePlacementName(cleaningId)

    return (
        <>
            <Ellipse />

            <div
                css={css`
                    display: grid;
                    grid-template-columns: auto 1fr auto;
                    gap: 8px;
                    align-items: center;
                `}
            >
                <div
                    css={css`
                        display: flex;
                        flex-wrap: wrap;
                        gap: 8px;
                        align-items: center;
                    `}
                >
                    <Typography
                        bolder
                        css={css`
                            font-size: 16px;
                            word-break: break-all;
                        `}
                    >
                        {placementName || "-"}
                    </Typography>

                    <Chip color="cleanerGrayLight">
                        {tour?.photoTour.title}
                    </Chip>
                </div>

                {/* 0の場合をケアするためundefinedとの一致判定している */}
                {cleaningPrice !== undefined ? (
                    <>
                        <span
                            css={css`
                                border-top: 1px dashed
                                    ${theme.palette.intentions.cleanerGray.main};
                            `}
                        />
                        <Typography
                            css={css`
                                font-size: 16px;
                                font-weight: 700;
                                color: #4a4a4a;
                            `}
                        >
                            {showJpYen(cleaningPrice)}
                        </Typography>
                    </>
                ) : null}
            </div>
        </>
    )
}

const Ellipse = () => {
    return <img src={EllipseIcon} alt="" />
}
